const throttle = (fn, time) => {
  let lastCall = 0;
  return function(...args) {
    const now = new Date().getTime();
    if (now - lastCall < time) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
};

export default throttle;
